import { render, staticRenderFns } from "./RetouchersOrderFuncBasedNewProstoyWrapper.vue?vue&type=template&id=4d4daa34&"
import script from "./RetouchersOrderFuncBasedNewProstoyWrapper.vue?vue&type=script&lang=js&"
export * from "./RetouchersOrderFuncBasedNewProstoyWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RetouchersOrderFuncBasedNewProstoyWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports